import { getLanguageData } from "../languageData";

export default getLanguageData("pt-BR");
